import { useLogto } from '@logto/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { createApiClient, type ReportRow, type Tour } from '../api/client';
import { ErrorBanner } from '../ui/ErrorBanner';
import { formatEur } from '../ui/format';

export function Home() {
  const { getAccessToken } = useLogto();
  const api = useMemo(() => createApiClient(getAccessToken), [getAccessToken]);
  const [tours, setTours] = useState<Tour[]>([]);
  const [rows, setRows] = useState<ReportRow[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const [ts, rep] = await Promise.all([api.getTours(), api.getReport()]);
      setTours(ts);
      setRows(rep);
      setError(null);
    } catch (err) {
      setError((err as Error).message);
    }
  }, [api]);

  useEffect(() => {
    void load();
  }, [load]);

  const operatorNet = rows.reduce((n, r) => n + r.operatorNet, 0);
  const pax = rows.reduce((n, r) => n + r.pax, 0);

  return (
    <section className="page">
      <header className="page-head">
        <h1>Visão geral</h1>
        <p className="subtle">Reservas, canais e receita da operação.</p>
      </header>
      <ErrorBanner message={error} />
      <div className="stat-grid">
        <div className="card stat-card">
          <div className="stat-label">Tours no catálogo</div>
          <div className="stat">{tours.length}</div>
        </div>
        <div className="card stat-card">
          <div className="stat-label">Lugares reservados</div>
          <div className="stat">{pax}</div>
        </div>
        <div className="card stat-card accent">
          <div className="stat-label">Receita do operador</div>
          <div className="stat money">{formatEur(operatorNet)}</div>
        </div>
      </div>
      <div className="quick-links">
        <Link className="btn btn-primary" to="/book">Nova reserva</Link>
        <Link className="btn" to="/dashboard">Ver receita</Link>
        <Link className="btn" to="/tours">Gerir tours</Link>
      </div>
    </section>
  );
}
